import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getInvoicesList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getInvoiceDetails();
  });
};

export const getInvoiceDetails = (): TListItem => {
  const invoiceStatuses = ['paid', 'pending'];
  return {
    id: faker.datatype.uuid(),
    merchant_id: faker.datatype.uuid(),
    created_at: faker.date.recent().toISOString(),
    number: faker.datatype.uuid(),
    amount: faker.finance.amount(1000, 10000, 2),
    currency_code: faker.finance.currencyCode(),
    state: (faker.helpers as any).arrayElement(invoiceStatuses),
    remarks: faker.fake('Test remark'),
    quotes: [],
  } as TListItem;
};
